import { RequestConfig, RequestConfigType } from '@client/common/utils/api/RequestConfig';

class SimilarProducts {
  public static fetch(sku: string): RequestConfigType {
    return RequestConfig.get(`/products/${sku}/similar-products`);
  }
}

export { SimilarProducts };
